window.jQuery(function () {
    let video = document.querySelector('[data-yt-video]');

    if (video) {
        let tag = document.createElement('script');

        tag.src = 'https://www.youtube.com/iframe_api';
        tag.async = false;

        document.getElementsByTagName('head')[0].appendChild(tag);
    }
});

window.onYouTubeIframeAPIReady = function () {
    let video = document.querySelector('[data-yt-video]');

    new YT.Player(`video-${video.dataset.ytVideo}`, {
        videoId: video.dataset.ytVideo,
        width: video.clientWidth,
        height: video.clientWidth * 9 / 16,
        playerVars: {
            autoplay: 0,
            controls: 1,
            showinfo: 0,
            modestbranding: 1,
            loop: 1,
            fs: 0,
            cc_load_policy: 0,
            iv_load_policy: 3,
            autohide: 0,
            mute: 1
        },
        events: {
            onReady: function (e) {
                e.target.mute();
            }
        }
    });
}